import { useContext, useEffect, useState } from 'react';
import { TestingHqContext } from '../../context/TestingHqContext';
import { get_testing_place_list, upsert_testing_place } from '../../utils/restapi';
import { number_format } from '../../utils/common';
import './cost_join.css';

const TestingCostJoin = ({ testingScheduleObj, onClose }) => {
  const { testingHqs } = useContext(TestingHqContext);

  // 선택상자 목록들
  const [testingPlaceObj, setTestingPlaceObj] = useState(null);

  // 고사장선택 목록
  const [testingPlaces, setTestingPlaces] = useState([]);

  // 포커스 인덱스 상태 추가
  const [focusIndex, setFocusIndex] = useState({ unitPrice: null, quantity: null });

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called`);

    if (testingScheduleObj.testing_id === undefined) {
      setTestingPlaces([]);
      return;
    }

    const json = {
      testing_id: testingScheduleObj.testing_id,
      hcodes: testingHqs.map(hq => hq.code).join(',')
    };

    console.log("getTestingPlace params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      setTestingPlaces(response.lists || []);
    } catch (error) {
      console.error("Error fetching place:", error);
      setTestingPlaces([]);
    }
  };

  const handleTestingPlaceChange = async (e) => {
    console.log("handleTestingPlaceChange:", e.target.value);
    const selectedId = Number(e.target.value);
    if (!selectedId) {
      setTestingPlaceObj({ data: { cost: { items: [] } } });
      return;
    }
    const selectedPlace = testingPlaces.find(place => place.testing_place_id === selectedId);
    setTestingPlaceObj(selectedPlace || { data: { cost: { items: [] } } });
  };

  const handleSave = async () => {
    console.log("handleSave:", testingPlaceObj);
    try {
      const json = testingPlaceObj;
      const response = await upsert_testing_place(json);
      console.log("Save response:", response);
      // 저장 로직 추가
      alert('저장되었습니다.');
    } catch (error) {
      console.error("Error saving data:", error);
      alert('저장 중 오류가 발생했습니다.');
    }
    // ...
    onClose();
  };

  const handleAddItem = () => {
    const newItem = { testing_cost_id: 0, name: '', unitPrice: 0, quantity: 0, amount: 0 };
    setTestingPlaceObj({
      ...(testingPlaceObj || {}),
      data: {
        ...(testingPlaceObj?.data || {}),
        cost: {
          ...(testingPlaceObj?.data?.cost || {}),
          items: [...(testingPlaceObj?.data?.cost?.items || []), newItem]
        }
      }
    });
  };

  const handleDelItem = (index) => {
    const newItems = testingPlaceObj.data?.cost?.items.filter((item, idx) => idx !== index);
    setTestingPlaceObj({
      ...testingPlaceObj,
      data: {
        ...testingPlaceObj.data,
        cost: {
          ...testingPlaceObj.data?.cost,
          items: newItems
        }
      }
    });
  };

  const updateCostItems = (newItems) => {
    const totalPrice = newItems.reduce((sum, item) => sum + (item.amount || 0), 0);
    //console.log('Total Price Updated:', totalPrice);
    setTestingPlaceObj({
      ...testingPlaceObj,
      data: {
        ...testingPlaceObj.data,
        cost: {
          ...testingPlaceObj.data.cost,
          items: newItems,
          price: totalPrice
        }
      }
    });
  };

  useEffect(() => {
    getTestingPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs.length]);
  
  useEffect(() => {
    if (
      testingPlaceObj &&
      (!testingPlaceObj.data?.cost?.items || testingPlaceObj.data.cost.items.length === 0)
    ) {
      handleAddItem();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingPlaceObj]);
  
  return (
    <div id="testing_cost_join">
      <div className="head">
        <h1>시험결과 보고</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>시험</label>
            <span>
              {testingScheduleObj?.testingObj?.typeName}
              {testingScheduleObj?.testingObj?.title}
              ({testingScheduleObj?.testStartDate} ~ {testingScheduleObj?.testStopDate})
            </span>
          </li>
          <li>
            <label>고사장</label>
            <span>
              <select
                value={testingPlaceObj?.testing_place_id ?? ''}
                onChange={handleTestingPlaceChange}
              >
                <option value="">▒ 선택 ▒</option>
                {testingPlaces.map(place => (
                  <option key={place.testing_place_id} value={place.testing_place_id}>
                    {place.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>청구합계</label>
            <span>
              <input type="number" min="0" value={testingPlaceObj?.data?.cost?.price ?? 0} onChange={(e) => setTestingPlaceObj({ ...testingPlaceObj, data: { ...testingPlaceObj.data, cost: { ...testingPlaceObj.data.cost, price: e.target.value } } })} />원
            </span>
          </li>
        </ul>
        <div className="table">
          <div className="thead">
            <div className="tr">
              <div className="th">No.</div>
              <div className="th">항목</div>
              <div className="th">단가.</div>
              <div className="th">수량</div>
              <div className="th">금액</div>
              <div className="th">
                <button onClick={handleAddItem}>추가</button>
              </div>
            </div>
          </div>
          <div className="tbody">
            {(testingPlaceObj?.data?.cost?.items || []).map((item, index) => (
              <div className="tr" key={index}>
                <div className="td">{index + 1}</div>
                <div className="td">
                  <input type="text" value={item.name} onChange={(e) => {
                    const newItems = [...testingPlaceObj.data.cost.items];
                    newItems[index].name = e.target.value;
                    setTestingPlaceObj({
                      ...testingPlaceObj,
                      data: {
                        ...testingPlaceObj.data,
                        cost: {
                          ...testingPlaceObj.data.cost,
                          items: newItems
                        }
                      }
                    });
                  }} />
                </div>
                <div className="td">
                  <input
                    type="number"
                    min="0"
                    value={focusIndex.unitPrice === index && item.unitPrice === 0 ? '' : item.unitPrice}
                    onFocus={() => setFocusIndex(f => ({ ...f, unitPrice: index }))}
                    onBlur={() => setFocusIndex(f => ({ ...f, unitPrice: null }))}
                    onChange={(e) => {
                      const newItems = [...testingPlaceObj.data.cost.items];
                      newItems[index].unitPrice = Number(e.target.value);
                      newItems[index].amount = newItems[index].unitPrice * newItems[index].quantity;
                      updateCostItems(newItems);
                    }}
                  />
                </div>
                <div className="td">
                  <input
                    type="number"
                    min="0"
                    value={focusIndex.quantity === index && item.quantity === 0 ? '' : item.quantity}
                    onFocus={() => setFocusIndex(f => ({ ...f, quantity: index }))}
                    onBlur={() => setFocusIndex(f => ({ ...f, quantity: null }))}
                    onChange={(e) => {
                      const newItems = [...testingPlaceObj.data.cost.items];
                      newItems[index].quantity = Number(e.target.value);
                      newItems[index].amount = newItems[index].unitPrice * newItems[index].quantity;
                      updateCostItems(newItems);
                    }}
                  />
                </div>
                <div className="td">{number_format(item.amount)}</div>
                <div className="td">
                  <button onClick={() => handleDelItem(index)}>삭제</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="foot">
        <button onClick={handleSave}>저장</button>
        <button onClick={() => onClose()}>닫기</button>
      </div>
    </div>
  );
};

export default TestingCostJoin;